import React from 'react';
import './pricing.css'

function Pricing() {
    return (
    <article className='card-article'>
    <ul className='pricing-ul'><h4>Our Services Explore our comprehensive services:</h4> 
        <li className='diamond'>Property Management</li>
        <li className='diamond'>Real Estate Consulting</li>
        <li className='diamond'>Maximizing Rental Income</li>
        <li className='diamond'>Navigating Real Estate Taxes</li>
        <li className='diamond'>Property Valuation and Market Analysis</li>
        <li className='diamond'>The Art of Negotiation: Sealing the Deal</li>
        <li className='diamond'>Demystifying Real Estate Investment Fundamentals </li>
    </ul>
  </article>
      );
}

export default Pricing;